// ** MUI Import
import { useTheme } from '@mui/material/styles'

// ** Type Import
// import { OwnerStateThemeType } from './'

const ringColor = (mode: 'light' | 'dark', grey400: string) =>
  mode === 'light' ? '#D8D6DE' : grey400

const CheckedIcon = () => {
  const theme = useTheme()

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9"
        cy="9"
        r="8.25"
        stroke={ringColor(theme.palette.mode, theme.palette.grey[400])}
        stroke-width="1.5"
      />
      <circle cx="9" cy="9" r="5" fill="#0BD68D" />
    </svg>
  )
}

const Icon = () => {
  const theme = useTheme()

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9"
        cy="9"
        r="8.25"
        stroke={ringColor(theme.palette.mode, theme.palette.grey[400])}
        stroke-width="1.5"
      />
    </svg>
  )
}

const Radio = () => {
  return {
    MuiRadio: {
      defaultProps: {
        icon: <Icon />,
        checkedIcon: <CheckedIcon />,
      },

      // styleOverrides: {
      //   root: ({ theme }: OwnerStateThemeType) => ({
      //     '&.Mui-checked': {
      //       '& svg': {
      //         fill: theme.palette.primary.main,
      //         filter: `drop-shadow(0 2px 3px rgba(${
      //           theme.palette.mode === 'light'
      //             ? theme.palette.customColors.main
      //             : '12, 16, 27'
      //         }, 0.16))`,
      //       },
      //       '&.Mui-disabled svg': {
      //         opacity: 0.4,
      //         filter: 'none',
      //         '& path:first-of-type': {
      //           fill: theme.palette.text.disabled,
      //         },
      //         '& path:last-of-type': {
      //           fill: theme.palette.common.white,
      //           stroke: theme.palette.common.white,
      //           opacity: theme.palette.mode === 'dark' ? 0.5 : 0.9,
      //         },
      //       },
      //     },
      //     '&.Mui-disabled:not(.Mui-checked) svg': {
      //       opacity: 0.5,
      //     },
      //     '&.Mui-checked.MuiRadio-colorSecondary svg path:first-of-type': {
      //       fill: theme.palette.secondary.main,
      //     },
      //     '&.Mui-checked.MuiRadio-colorSuccess svg path:first-of-type': {
      //       fill: theme.palette.success.main,
      //     },
      //     '&.Mui-checked.MuiRadio-colorError svg path:first-of-type': {
      //       fill: theme.palette.error.main,
      //     },
      //     '&.Mui-checked.MuiRadio-colorWarning svg path:first-of-type': {
      //       fill: theme.palette.warning.main,
      //     },
      //     '&.Mui-checked.MuiRadio-colorInfo svg path:first-of-type': {
      //       fill: theme.palette.info.main,
      //     },
      //   }),
      // },
    },
  }
}

export default Radio
